export default __webpack_public_path__ + "static/media/four_of_wands.b04b338e.png";